export default __webpack_public_path__ + "assets/images/438db29790d174b21b73ea349271c6ab.png";